import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { handleWidgetActionFromTwig } from '@entities/widget-card/lib';
import { useWidgetModals, WidgetModalController } from '@features';
import { AiGenerateButton, Popup } from '@shared/ui';
import { AILoader } from '@shared/ui';

import cls from './GenerateEstimate.module.css';
import { GenerateEstimateModal } from './GenerateEstimateModal';
import { useGenerateEstimate } from '../lib/hooks/useGenerateEstimate';

interface GenerateEstimateProps {
    classes?: string;
}

export const GenerateEstimate = ({ classes }: GenerateEstimateProps) => {
    const {
        onHideModal,
        isOpen,
        onShowModal,
        isPending,
        formGenerateEstimate,
        onFormGenerateEstimate,
        onGenerateEstimate,
        isOpenPopup,
        onHidePopup,
        data,
        errorsForm,
        onSelect,
    } = useGenerateEstimate();

    const { openDetails, openOnlyAdmin } = useWidgetModals();

    const { t } = useTranslation();

    return (
        <div className={cn(cls.GenerateEstimate, [classes])}>
            {isOpenPopup && (
                <Popup onHidePopup={onHidePopup} isOpen={isOpenPopup} contentText={data?.message} />
            )}
            {isPending && <AILoader />}
            {isOpen && (
                <GenerateEstimateModal
                    formGenerateEstimate={formGenerateEstimate}
                    onFormGenerateEstimate={onFormGenerateEstimate}
                    onGenerateEstimate={onGenerateEstimate}
                    isOpen={isOpen}
                    onHideModal={onHideModal}
                    errorsForm={errorsForm}
                    onSelect={onSelect}
                />
            )}
            <div className={cls.buttonWrapper}>
                <AiGenerateButton
                    classes={cls.buttonAi}
                    iconName="generateEstimate"
                    cb={() => {
                        handleWidgetActionFromTwig({
                            elementIdentifier: 'renderGenerateEstimate',
                            onWidgetAvailable: onShowModal,
                            onOpenDetails: openDetails,
                            onOpenOnlyAdmin: openOnlyAdmin,
                        });
                    }}
                >
                    {t('GenerateEstimate.return.GenerateEstimate.buttonWrapper.button')}
                </AiGenerateButton>
            </div>

            <WidgetModalController />
        </div>
    );
};
